<template>
  <div id="schedule" class="container flex-full">
    <div class="row">
      <div class="col-xs-12">
        <breadcrumbs class="pt20 pb20 " :with-homepage="true" :active-route="$t('Terms of delivery')" />
      </div>
    </div>
    <!--<div class="row">-->
    <!--<h3 class="align-center col-xs-12">-->
    <!--Про нас-->
    <!--</h3>-->
    <!--<p>-->
    <!--Вже давно відомо, що читабельний зміст буде заважати зосередитись людині, яка оцінює композицію сторінки. Сенс використання Lorem Ipsum полягає в тому, що цей текст має більш-менш нормальне розподілення літер на відміну від, наприклад, "Тут іде текст. Тут іде текст." Це робить текст схожим на оповідний. Багато програм верстування та веб-дизайну використовують Lorem Ipsum як зразок і пошук за терміном "lorem ipsum" відкриє багато веб-сайтів, які знаходяться ще в зародковому стані. Різні версії Lorem Ipsum з'явились за минулі роки, деякі випадково, деякі було створено зумисно (зокрема, жартівливі).-->
    <!--</p>-->
    <!--</div>-->
    <div class="row center-xs" v-if="currentPartner && currentPartner.hasOwnProperty('schedule')">
      <section class="col-md-8 col-xs-12" v-if="currentPartner.schedule.delivery_conditions">
        <h1 class="align-center cl-accent col-xs-12 h3">
          {{ $t('Delivery price') }}
        </h1>
        <div class="row center-xs px15 delivery_conditions" v-html="currentPartner.schedule.delivery_conditions" />
      </section>
      <delivery-windows :store="currentPartner" />
      <delivery-windows-pickup v-if="currentPartnerCode === 'novus'" />
    </div>
    <h3 v-if="currentPartnerCode === 'novus'" class="align-center">
      &nbsp;Умови доставки
    </h3>
    <div v-if="currentPartnerCode === 'novus'" class="row center-xs px15">
      <ul class="col-xs-12 col-md-9 light weight-300 start-xs">
        <li class="mb10">
          Об'ємні одиниці товару, наприклад: кошик 50л., карнизи для ванни, санчата - доставляються на індивідуальних умовах.
        </li>
        <li class="mb10">
          При замовленні більше, ніж 50 одиниць одного й того самого товару, з Вами обов'язково зв'яжуться для уточнення його наявності та механізму оплати: якщо в супермаркеті не буде необхідної кількості товару й потрібна буде спеціальна поставка, треба буде зробити передоплату.
        </li>
        <li class="mb10">
          При замовленні товарів підакцизної групи (алкоголь, тютюн) на суму від 9000 грн з Вами обов'язково зв'яжуться для уточнення його наявності та механізму оплати: для резерву товару та спеціальної доставки необхідно буде внести 50% передоплату.
        </li>
        <li class="mb10">
          Вам потрібно зробити декілька окремих замовлень (на різні чеки), але Ви хочете, щоб вони були об'єднані в одну доставку: при оформленні доставки, що складається з декількох, але не більше трьох, замовлень на одну адресу, на одне вікно доставки та з одного магазину -  вартість доставки буде розраховуватись як для одного замовлення, що також включає в себе сукупну вагу по усім замовленням. Якщо Вам необхідно буде оформити доставку, що складається з чотирьох і більше замовлень, то вартість доставки буде збільшуватися на 10 грн. за кожне наступне замовлення, а перерахунок вартості ваги буде здійснюватись відповідно до тарифів зазначених вище.
        </li>
        <li class="mb10">
          Служба доставки залишає за собою право відмінити замовлення у випадку неможливості його доставки (паводки, землетруси, катаклізми, складна транспортна ситуація у місті, або якщо адреса пункту доставки знаходиться в зоні, до якої неможливо під'їхати на автомобілі. У випадку відміни замовлення, Клієнт може самостійно повторити замовлення на сайті.
        </li>
        <li class="mb10">
          Ми залишаємо за собою право проводити інформування Клієнтів про відміну замовлень шляхом смс-повідомлення (максимум за 2 години до кінця обраного вікна доставки).
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DeliveryWindows from '../components/theme/blocks/Home/DeliveryWindows';
import DeliveryWindowsPickup from '../components/theme/blocks/Home/DeliveryWindowsPickup';
import { mapGetters } from 'vuex';
import { onlineHelper } from '@vue-storefront/core/helpers';
import Breadcrumbs from '../components/core/Breadcrumbs.vue'
import {htmlDecode} from '@vue-storefront/core/filters';

export default {
  name: 'Schedule',
  components: {
    Breadcrumbs,
    DeliveryWindows,
    DeliveryWindowsPickup
  },
  // The delivery conditions and title read currentPartner; App.vue's store
  // watcher doesn't fire for the initial route.
  async asyncData ({ store, route }) {
    if (!route.params.store) {
      return
    }
    await store.dispatch('partners/ensureCurrentPartner', { code: route.params.store, locationCode: route.params.locationCode })
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      currentPartnerCode: 'partners/getCurrentPartnerCode',
      currentPartner: 'partners/getCurrentPartner'
    }),
    isOnline () {
      return onlineHelper.isOnline
    },
    isShopPage () {
      return this.currentPartner !== undefined && this.currentPartner.display_mode === 'shop'
    }
  },
  mounted () {
    if (!this.isLoggedIn && localStorage.getItem('redirect')) {
      this.$bus.$emit('modal-show', 'modal-signup')
    }
    if (this.isShopPage) {
      this.$bus.$emit('toggle-category-panel')
    }
  },
  watch: {
    isLoggedIn () {
      const redirectObj = localStorage.getItem('redirect')
      if (redirectObj) this.$router.push(redirectObj)
      localStorage.removeItem('redirect')
    }
  },
  metaInfo () {
    if (this.currentPartner !== undefined) {
      let type = this.currentPartner.display_mode === 'food'
        ? 'закладу'
        : 'магазину'
      return {
        title: `Умови доставки з ${type} ${this.currentPartner.title}`,
        meta: [
          {
            vmid: 'description',
            name: 'description',
            content: 'Привеземо Вам усе що забажаєте. У нас в каталозі Ви можете переглянути та замовити страви та товари з найкращих закладів харчування, супермаркетів та гіпермаркетів міста'
          }
        ]
      }
    }
  }
}
</script>
<style scoped>
  .delivery_conditions >>> ul {
    text-align: left;
    list-style: none;
    font-family: 'TTNorms Light', sans-serif;
    width: 100%!important;
    flex: 1 1 100%;
    max-width: unset;
  }
  .delivery_conditions >>> li {
    font-size: 14px;
    padding-left: 7px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .delivery_conditions >>> li::before {
    content: "";
    background-color: #11bb2e;
    display: inline-block;
    font-size: 35px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-left: -14px;
    margin-right: 5px;
    margin-bottom: 2px;
  }

  .cl-accent {
    @media (max-width: 555px) {
      margin: 0;
    }
  }
.bold{
  font-family: 'TTNorms Bold', sans-serif;
}

</style>
